import { render, staticRenderFns } from "./material-change-modal.vue?vue&type=template&id=5e570049&scoped=true"
import script from "./material-change-modal.vue?vue&type=script&lang=js"
export * from "./material-change-modal.vue?vue&type=script&lang=js"
import style0 from "./material-change-modal.vue?vue&type=style&index=0&id=5e570049&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e570049",
  null
  
)

export default component.exports